<h2 class="text-base font-semibold mt-1">Abteilung auswählen</h2>

<div class="c column center-v no-wrap">
  <soft-field-ok
    #fok
    [name]="'abteilung'"
    [placeholder]="'Abteilung auswählen'"
    [title]="'Abteilung'"
    [value]="value()"
    [template]="valueTemplate"
    (valueChange)="onValueChanged($event)"
  >
  </soft-field-ok>

  <ng-template #valueTemplate>
    {{ fok?.value?.id }}
  </ng-template>
</div>
